import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type LogFieldProps = {
  label: string;
  value: string | undefined;
};
const LogField = t0 => {
  const $ = _c(15);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "details.logs.detailsDialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== label) {
    t2 = <span className="text-body-2 text-primary">{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !!value;
  const t4 = !value;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = cx("max-w-[80%] text-right wrap-anywhere md:wrap-normal", {
      "text-snippet-2 text-primary": t3,
      "text-body-2 text-tertiary": t4
    });
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t || $[7] !== value) {
    t6 = value || t(_temp);
    $[6] = t;
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <div className="flex items-center justify-between gap-2">{t2}{t7}</div>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default LogField;
function _temp($) {
  return $.empty;
}